import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-brown font-normal text-xl leading-[28px]" }
const _hoisted_2 = {
  key: 0,
  class: "w-full h-px bg-ternary my-8"
}
const _hoisted_3 = { class: "activation-title mb-[20px]" }
const _hoisted_4 = {
  key: 1,
  class: "mb-4 font-semibold"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }

import { computed } from "vue";
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionFAQ',
  props: {
    faqTemplateName: {},
    title: {},
    collapseButtonText: {}
  },
  setup(__props: any) {

const props = __props;

const { tm } = useI18n();

const faq = computed(() => tm(props.faqTemplateName));

const getParagraphClass = (nextItem?: any) => {
  if (!nextItem) return "";
  if (nextItem.type === "list") return "mb-4";
  if (nextItem.type === "paragraph") return "mb-6";
  if (nextItem.type === "subtitle") return "mb-6";
  return "";
};

const getListCLass = (nextItem?: any) => {
  if (!nextItem) return "";
  if (nextItem.type !== "title") return "mb-6";
  return "";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, null, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.title), 1)
    ]),
    "faq-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item.type === 'title')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (index > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                    : _createCommentVNode("", true),
                  _createElementVNode("h4", _hoisted_3, _toDisplayString(item.content), 1)
                ], 64))
              : (item.type === 'subtitle')
                ? (_openBlock(), _createElementBlock("h5", _hoisted_4, _toDisplayString(item.content), 1))
                : (item.type === 'paragraph')
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 2,
                      class: _normalizeClass(getParagraphClass(faq.value[index + 1]))
                    }, [
                      (typeof item.content === 'string')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.content), 1))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.content, (seq, seqIndex) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: seqIndex,
                              class: _normalizeClass({ 'font-bold': seq.type === 'bold' })
                            }, _toDisplayString(seq.text), 3))
                          }), 128))
                    ], 2))
                  : (item.type === 'list')
                    ? (_openBlock(), _createElementBlock("ul", {
                        key: 3,
                        class: _normalizeClass(["list-disc pl-6 space-y-2", getListCLass(faq.value[index + 1])])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (element, elementIndex) => {
                          return (_openBlock(), _createElementBlock("li", { key: elementIndex }, [
                            (typeof element === 'string')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(element), 1))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(element, (elementSeq, seqIndex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: seqIndex,
                                    class: _normalizeClass({ 'font-bold': elementSeq.type === 'bold' })
                                  }, _toDisplayString(elementSeq.text), 3))
                                }), 128))
                          ]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(props.collapseButtonText), 1)
    ]),
    _: 1
  }))
}
}

})